class PortfolioRuleEngine {
    constructor(portfolioDocument) {
        this.portfolioDocument = portfolioDocument;
        this.userID = localStorage.getItem('uid');
        this.companyID = localStorage.getItem('cid');


    }

    allowEdit(){
        return true;
    }

    isSMA(){
        let params = this.portfolioDocument?.properties ?? {};
        if (!params?.linked_portfolio){
            return false;
        }
        return true;
    }
}

export default PortfolioRuleEngine;